import React from 'react';
import {Container} from "react-bootstrap";
import {Helmet} from "react-helmet";

export const PrivacyPolicy: React.FC = () => (
    <>
        <Helmet>
            <title>Privacy Policy</title>
            <meta
                name="description"
                content="Privacy policy of our service."
            />
        </Helmet>

        <Container>
            <h1>Privacy Policy</h1>
            <p><strong>Effective Date:</strong> April 17, 2025</p>

            <h2>1. Information We Collect</h2>
            <ul>
                <li><strong>Account Info:</strong> Name, email when you sign up.</li>
                <li><strong>Payment Info:</strong> Collected by Stripe; we do not store your full card details.</li>
                <li><strong>Usage Data:</strong> Pages visited, session duration, IP address, browser type.</li>
                <li><strong>Cookies & Tracking:</strong> Used for analytics, login sessions, and Google AdSense.</li>
            </ul>

            <h2>2. How We Use Your Information</h2>
            <ul>
                <li>To provide and maintain our Service.</li>
                <li>To process payments and manage your subscription.</li>
                <li>For analytics and improvements.</li>
                <li>To display relevant ads via Google AdSense.</li>
            </ul>

            <h2>3. Third‑Party Services</h2>
            <ul>
                <li><strong>Google AdSense:</strong> May use cookies and collect data for ad personalization.</li>
                <li><strong>Stripe:</strong> Handles all payment processing independently.</li>
            </ul>

            <h2>4. Data Sharing & Disclosure</h2>
            <p>
                We do not sell your personal data. We may share information with service providers
                who help us operate (e.g. Stripe, Google).
            </p>

            <h2>5. Your Choices</h2>
            <ul>
                <li>You can disable cookies via browser settings (may affect functionality).</li>
                <li>You may request deletion of your account by emailing support@litlap.com.</li>
            </ul>

            <h2>6. Security</h2>
            <p>
                We implement reasonable measures to protect your data, but no internet transmission is 100% secure.
            </p>

            <h2>7. Children’s Privacy</h2>
            <p>
                Our Service is not intended for children under 13. We do not knowingly collect their data.
            </p>

            <h2>8. Changes to This Policy</h2>
            <p>
                We’ll post any updates here with a new effective date. Continued use equals acceptance.
            </p>

            <h2>9. Contact Us</h2>
            <p>
                Questions? Email <a href="mailto:support@litlap.com">support@litlap.com</a>.
            </p>
        </Container>
    </>

);